import request from '@/utils/request'

/**
 * 系统配置相关 API
 */

// 获取系统配置
export const getConfig = () => {
  return request({
    url: '/system/basic/conf',
    method: 'post'
  })
}

// 获取协议内容
export const allXieyi = (data) => {
  return request({
    url: '/system/basic/all_xieyi',
    method: 'post',
    data
  })
}

/**
 * 平台概览统计（宣传/引导页）
 * POST /system/stats/platform_overview
 * @param {{ regcode?: string }} data 可选邀请码
 */
export const getPlatformOverview = (data = {}) => {
  return request({
    url: '/system/stats/platform_overview',
    method: 'post',
    data
  })
}
